import { InvoicesService, IInvoiceSummary } from "../../services/index";
import * as moment from "moment";

class QuotationsSummaryController implements ng.IComponentController {

    private sortType: string;
    private startDate: any;
    private endDate: any;
    private summaries: IInvoiceSummary[];
    private moment: any;
    private totalAmount: number;
    private totalInvoiceCount: number;
    private employeeType: string = "all";

    constructor(
        private InvoicesService: InvoicesService,
        private $scope: ng.IScope
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.sortType = 'account.name';
        this.moment = require('moment');

        // Default to current month
        this.startDate = this.moment().startOf('month').toDate();
        this.endDate = this.moment().endOf('month').toDate();

        this.getSummary();
    }

    startDateBeforeRender($dates) {
    }

    endDateBeforeRender($view, $dates) {
        if (this.startDate) {
            var activeDate = moment(this.startDate).subtract(1, $view).add(1, 'minute');

            $dates.filter(function (date) {
                return date.localDateValue() <= activeDate.valueOf();
            }).forEach(function (date) {
                date.selectable = false;
            });
        }
    }

    prevMonth() {
        this.startDate = this.moment(this.startDate).subtract(1, 'month').startOf('month').toDate();
        this.endDate = this.moment(this.endDate).subtract(1, 'month').endOf('month').toDate();
    }
    
    nextMonth() {
        this.startDate = this.moment(this.startDate).add(1, 'month').startOf('month').toDate();
        this.endDate = this.moment(this.endDate).add(1, 'month').endOf('month').toDate();
    }

    getSummary() {
        this.InvoicesService.getSummary(this.startDate, this.endDate, this.employeeType).then((result: IInvoiceSummary[]) => {
            this.summaries = result;
            this.calculateTotals();
        });
    }

    calculateTotals() {
        this.totalAmount = 0;
        this.totalInvoiceCount = 0;
        if (this.summaries) {
            this.summaries.forEach(s => {
                this.totalAmount += s.totalAmount;
                this.totalInvoiceCount += s.totalInvoiceCount;
            });
        }
    }
}

export const quotationsSummaryComponent: ng.IComponentOptions = {
    controller: QuotationsSummaryController,
    template: require('./quotations.summary.html')
};




// WEBPACK FOOTER //
// ./src/app/modules/quotations/quotations.summary.component.ts